import palette from '../palette';

const MuiDialogContent = {
  styleOverrides: {
    root: {
      backgroundColor: palette.surface.light,
      fontSize: '16px',
    },
  },
  variants: [
    {
      props: { variant: 'batchCreation' },
      style: {
        paddingBottom: '100px',
      },
    },
  ],
};

export default MuiDialogContent;
